// import { getUser, getToken } from "../Common";
import { getUser, getToken } from "../Utils/Common";
import axios from "axios";
import qs from 'qs';
// import toast from "react-hot-toast";

const postCall = async (url, data) => {
    const config = {
        headers: {
            'api-key': process.env.REACT_API_KEY,
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    }
    try {
        const response = await axios.post(process.env.REACT_APP_LINK+"/"+url, qs.stringify(data), config);
        return response.data;
    } catch (error) {
        throw error.response;
    }
};

export const getCall = (url, parameters) => {
    const config = {
        headers: {
            'api-key': "daccfc89-ff47-4ce1-99bf-5ad2d8f57282",
        },
        params: parameters
    }

    return axios.get(process.env.REACT_APP_LINK + url, config);
};

export const erpGetCall = (url, parameters) => {
    const config = {
        headers: {
            "api-key": "daccfc89-ff47-4ce1-99bf-5ad2d8f57282",
            "Content-Type":"application/json",
        },
        params: parameters
    }

    return axios.get(process.env.REACT_APP_LINK + url, config);
};

export const UseGetRequest = async (url, filter, isErp=false) => {
    try {
        if (isErp) {
            const response = await erpGetCall(url, {requester: getUser(), token: getToken(), ...filter});
            return {data: response.data}
        } else {
            const response = await getCall(url, {requester: getUser(), token: getToken(), ...filter});
            return {data: response.data}
        }
    } catch (error) {
        return {error: error.response}
    }
}

// DON'T BE TRICKED, THIS MAY BE POST BUT THIS ACTUALLY IS A GET INSIDE A POST METHOD.
// BACKEDN tingz I have to conform to
export const UsePostRequest = async (url, payload) => {
    try {
        const response = await postCall(url, {requester: getUser(), token: getToken(), ...payload});
        return {data: response.data || response.employees, response: response}
    } catch (error) {
        return {error: error.response}
    }
}
